/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Scene_Descriptions_DescriptionInputs */

const en_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate AI-powered scene descriptions for each shot change in the current video.`)
};

const fr_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer des descriptions de scènes alimentées par l'IA pour chaque changement de plan dans la vidéo actuelle.`)
};

const de_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generiert KI-gestützte Szenenbeschreibungen für jeden Schnitt im aktuellen Video.`)
};

const it_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera descrizioni di scena basate sull'intelligenza artificiale per ogni cambio di inquadratura nel video corrente.`)
};

const ru_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сгенерировать описания сцен на основе искусственного интеллекта для каждой смены кадра в текущем видео.`)
};

const es_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera descripciones de escenas mediante inteligencia artificial para cada cambio de plano en el vídeo actual.`)
};

const zh_cn2_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为当前视频中的每次镜头切换生成 AI 驱动的场景描述。`)
};

const ja_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在の動画におけるショットの切り替えごとに、AIを活用したシーン説明を生成します。`)
};

const hi_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान वीडियो में प्रत्येक शॉट परिवर्तन के लिए एआई-संचालित दृश्य विवरण उत्पन्न करें।`)
};

const pt_pt2_automatic_scene_descriptions_description = /** @type {(inputs: Automatic_Scene_Descriptions_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gere descrições de cena com inteligência artificial para cada mudança de plano no vídeo atual.`)
};

/**
* | output |
* | --- |
* | "Generate AI-powered scene descriptions for each shot change in the current video." |
*
* @param {Automatic_Scene_Descriptions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_scene_descriptions_description = /** @type {((inputs?: Automatic_Scene_Descriptions_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Scene_Descriptions_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_scene_descriptions_description(inputs)
	if (locale === "de") return de_automatic_scene_descriptions_description(inputs)
	if (locale === "it") return it_automatic_scene_descriptions_description(inputs)
	if (locale === "ru") return ru_automatic_scene_descriptions_description(inputs)
	if (locale === "es") return es_automatic_scene_descriptions_description(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_scene_descriptions_description(inputs)
	if (locale === "ja") return ja_automatic_scene_descriptions_description(inputs)
	if (locale === "hi") return hi_automatic_scene_descriptions_description(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_scene_descriptions_description(inputs)
	return en_automatic_scene_descriptions_description(inputs)
});